import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { Heading4, Heading6 } from '../../../elements';
import PrintButton from '../../../print-button/PrintButton';
import OrderSpecificationRow from '../read-report-content/components/OrderSpecificationRow';
import ReportTable from '../read-report-content/components/ReportTable';
const useStyles = makeStyles({
    printButton: {
        marginTop: '4rem',
        float: 'right',
        // Don't display the print button when printing .
        '@media print': {
            display: 'none'
        }
    },
    readArchiveReport: {
        float: 'none',
    },
    checkpoints: {
        // Adjust the position of the grid, so the checkpoint titles (column 2) is aligned with the section header.
        // This needs to correlate with gridTemplateColumn width plus the columnGap.
        marginLeft: '-5rem',
        display: 'grid',
        //two columns: discrepancy indicator and checkpoint label
        gridTemplateColumns: '4rem auto',
        gridTemplateRows: '4rem',
        columnGap: '1rem',
        rowGap: '0.5rem',
        alignItems: 'center'
    },
    checkpointLabel: {
        gridColumnStart: 2 //checkpoint label should always be displayed in column 2.
    },
    // Avoid breaking the container when printing.
    noPageBreak: {
        'page-break-inside': 'avoid'
    }
});
const printArchivedReport = () => {
    window.print();
};
const ReadArchivedReport = observer(({ i18n, reportStore, formatDate, formatTime, ReportSummary }) => {
    const classes = useStyles();
    const intl = useIntl();
    const hasCheckpointData = reportStore.hasCheckpointData;
    return (React.createElement(React.Fragment, null,
        React.createElement(PrintButton, { text: i18n('common.print'), className: classes.printButton, onClick: () => printArchivedReport() }),
        React.createElement("div", { className: classNames('ReadReportContent', classes.readArchiveReport) },
            React.createElement(React.Fragment, null,
                ReportSummary && React.createElement(ReportSummary, Object.assign({}, { i18n, reportStore })),
                React.createElement("div", { className: 'ReadReportContent__Section' },
                    React.createElement(Heading4, null, i18n('readreport.label.orderspecifications')),
                    React.createElement("div", { className: 'ScrollableContainer ReadReportContent__Space--medium' },
                        React.createElement(ReportTable, { className: "ReadReport__Table TwoColTable" },
                            React.createElement(OrderSpecificationRow, Object.assign({}, { i18n, formatDate, formatTime, reportStore, intl, isCup: true }))))),
                hasCheckpointData && React.createElement(ArchivedCheckpointList, Object.assign({}, { reportStore, i18n, classes }))))));
});
const ArchivedCheckpointList = ({ reportStore, i18n, classes }) => {
    const checkpoints = reportStore.archivedCheckpoints;
    if (checkpoints.length < 1) {
        return null;
    }
    return (React.createElement("div", { className: classNames(['ReadReportContent__Section', classes.noPageBreak]) },
        React.createElement(Heading4, null, i18n('readreport.label.controlpoints')),
        React.createElement("div", { className: classes.checkpoints }, checkpoints.map((c) => (React.createElement(React.Fragment, { key: c.type },
            React.createElement(Heading6, { className: classes.checkpointLabel }, i18n(`service.checkpoints.${c.type}`))))))));
};
export default ReadArchivedReport;
